import { ICase, ICasePartial } from '../../../app/entities/Case'

export function getCasesByOrderObjectId(orderOjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/cases/order/${orderOjectId}`,
  }
}

export function createCase(
  caseProps: ICasePartial,
  orderObjectId: string,
  technicianObjectId?: string,
) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/cases`,
    body: {
      caseProps,
      orderObjectId,
      ...(technicianObjectId && { technicianObjectId }),
    },
  }
}

export function updateCase(caseProps: ICase, technicianObjectId?: string) {
  return {
    method: 'PUT',
    url: `${process.env.REACT_APP_ORIGIN}/cases`,
    body: {
      caseEntity: caseProps,
      technicianObjectId,
    },
  }
}

export function getAwsSsmParameter(parameterName: string) {
  const endpoint = `${
    process.env.REACT_APP_ORIGIN
  }/aws-ssm-parameter?parameterName=${encodeURIComponent(parameterName)}`

  return {
    url: endpoint,
    method: 'GET',
  }
}

export function getTechniciansByLocationObjectId(locationObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/location/${locationObjectId}?includeInactive=true`,
  }
}

export function getTechnicianAssignedToOrder(orderObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/assigned-to-work-order?orderObjectId=${orderObjectId}`,
  }
}
